export const UserRole = {
  ClubUser: 1,
  FanVestor: 2,
} as const
